import List from '../../List';
import React from 'react';

const SubContractor = ({
  serviceData = {
    organizationUsesSubcontractor: false,
    apiUserName: '',
    apiAccessContactInformation: {
      apiAccessContactPerson: {
        organizationName: '',
        businessId: '',
        firstName: '',
        lastName: '',
        email: ''
      }
    }
  },
  i18n
}) => (
  <List>
    <List.Item
      title={i18n(
        'forms.servicecatalogue.page_serviceCatalogueInfo.inApi.organizationUsesSubcontractor'
      )}
      value={serviceData.organizationUsesSubcontractor}
    />
    {serviceData.organizationUsesSubcontractor ? (
      <>
        <List.Item
          title={i18n('intermediary.inapi.apiUserNameLabel')}
          value={serviceData.apiUserName}
        />
        {['organizationName', 'businessId', 'email'].map(prop => (
          <List.Item
            key={prop}
            title={i18n(
              `forms.servicecatalogue.page_serviceCatalogueInfo.inApi_v4.${prop}`
            )}
            value={
              serviceData.apiAccessContactInformation.apiAccessContactPerson[
                prop
              ]
            }
          />
        ))}
      </>
    ) : null}
  </List>
);

export default SubContractor;
